import { parseTime } from '@/utils'
export const STAGING_CONSTANT = {
  initTable: [
    { title: 'Material Id', dataIndex: 'objectId', width: '15%' },
    { title: 'Req.Qty', dataIndex: 'reqQty', width: '10%' },
    { title: 'Req.Region', dataIndex: 'regionCode', width: '15%' },
    { title: 'Job Id', dataIndex: 'jobId', width: '15%' },
    { title: 'Sub Job Id', dataIndex: 'subJobId', width: '20%' },
    {
      title: 'Estimated Start Time',
      dataIndex: 'estStart',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.estStart - b.estStart,
      width: '25%',
      customRender({ text }) {
        return parseTime(text, '{y}/{m}/{d} {h}:{i}')
      },
    },
  ],
  availableStock: [
    { title: 'Tag Id', dataIndex: 'tagId', width: '25%' },
    { title: 'Material Id', dataIndex: 'objId', width: '25%' },
    { title: 'Object Qty', dataIndex: 'objQty', width: '25%' },
    {
      title: 'FIFO In',
      dataIndex: 'fifoIn',
      width: '25%',
      sorter: (a, b) => a.fifoIn - b.fifoIn,
      customRender({ text }) {
        return parseTime(text, '{y}/{m}/{d} {h}:{i}')
      },
    },
  ],
  fifoViolation: [
    { title: 'Tag Id', dataIndex: 'tagId', width: '25%' },
    { title: 'Material Id', dataIndex: 'objId', width: '25%' },
    { title: 'Jump Sequence', dataIndex: 'jumpSeq', width: '25%' },
    {
      title: 'Created On',
      dataIndex: 'createOn',
      width: '25%',
      sorter: (a, b) => a.createOn - b.createOn,
      defaultSortOrder: 'descend',
      customRender({ text }) {
        return parseTime(text, '{y}/{m}/{d} {h}:{i}')
      },
    },
  ],
  incomingStock: [
    // { title: 'Req.Id', dataIndex: 'reqId', width: '15%' },
    { title: 'Material Id', dataIndex: 'objId', width: '15%' },
    { title: 'Req. Qty', dataIndex: 'reqQty', width: '10%' },
    { title: 'Act. Qty', dataIndex: 'actQty', width: '10%' },
    {
      title: 'Req. Arrival Time',
      dataIndex: 'reqArrTime',
      width: '25%',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.reqArrTime - b.reqArrTime,
      customRender({ text }) {
        return parseTime(text, '{y}/{m}/{d} {h}:{i}')
      },
    },
    {
      title: 'Created On',
      dataIndex: 'createOn',
      width: '25%',
      sorter: (a, b) => a.createOn - b.createOn,
      defaultSortOrder: 'descend',
      customRender({ text }) {
        return parseTime(text, '{y}/{m}/{d} {h}:{i}')
      },
    },
  ],
  leadTime: [
    { title: 'Req.Id', dataIndex: 'reqId', width: '20%' },
    { title: 'Material Id', dataIndex: 'objId', width: '20%' },
    { title: 'Req. Qty', dataIndex: 'reqQty', width: '20%' },
    {
      title: 'Req. Arrival Time',
      dataIndex: 'reqArrTime',
      width: '25%',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.reqArrTime - b.reqArrTime,
      customRender({ text }) {
        return parseTime(text, '{y}/{m}/{d} {h}:{i}')
      },
    },
    {
      title: 'Act. Arrival Time',
      dataIndex: 'actArrTime',
      width: '25%',
      sorter: (a, b) => a.actArrTime - b.actArrTime,
      customRender({ text }) {
        return parseTime(text, '{y}/{m}/{d} {h}:{i}')
      },
    },
  ],
}
export const COLS = [
  {
    name: 'Available Stock',
    field: 'availableStock',
  },
  {
    name: 'FIFO Violation',
    field: 'fifoViolation',
  },
  {
    name: 'Incoming Stock',
    field: 'incomingStock',
  },
  {
    name: 'Avg.Rep.Lead Time',
    field: 'leadTime',
    unit: 'Hr',
  },
]

export default STAGING_CONSTANT
